import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import 'paymentfont/css/paymentfont.css'
import React from 'react'
import { hydrate, render } from 'react-dom'
import { ServerStyleSheet } from 'styled-components'
import App from './App'
import './assets/fonts/mont/stylesheet.css'
import './assets/fonts/segoe/stylesheet.css'
import config from './config'
import { setConfig } from './externals/api/config'
import './i18n'
import reportWebVitals from './reportWebVitals'
import './reset.css'

setConfig('API_URL', config.API_URL)
setConfig('WORKERS_URL', config.WORKERS_URL)

Sentry.init({
  dsn: 'https://4ae917dda28c420791d162c0d46f1300@o468983.ingest.sentry.io/5863221',
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
})

const rootElement = document.getElementById('root')

if (rootElement?.hasChildNodes()) {
  hydrate((
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ), rootElement)
} else {
  if (navigator.userAgent.includes('Prerender')) {
    const sheet = new ServerStyleSheet()

    const jsx = sheet.collectStyles(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )

    render(jsx, rootElement)

    try {
      const styleTags = sheet.getStyleTags()
      const allStyledElements = document.querySelectorAll('style')

      allStyledElements[allStyledElements.length - 1]?.insertAdjacentHTML('afterend', styleTags)
    } catch {}

    sheet.seal()
  }

  render((
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ), rootElement)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
